module.exports = __webpack_public_path__ + "static/media/jurnal_kas.faffdf0a.png";